import React, { useState } from 'react';
import { Box, Typography, Switch, Grid, Card, CardContent, Button, Divider } from '@mui/material';

export const PricingSection = () => {
    const [annual, setAnnual] = useState(false);

    const plans = [
        {
            title: 'Basic',
            monthlyPrice: 0,
            annualPrice: 0,
            features: [
                'Access to public recipes and foodstuffs',
                'Create public meals and foodstuffs.',
                'Basic tracking',
                'Ads'
            ],
        },
        {
            title: 'Standard',
            monthlyPrice: 49,
            annualPrice: 499,
            features: [
                'All features from Basic plan',
                'Private recipes',
                'No ads',
                'Priority support',
            ],
        },
        {
            title: 'Pro',
            monthlyPrice: 199,
            annualPrice: 1999,
            features: [
                'All features from Standard plan',
                'Meals calculated just for your needs'
            ],
        },
    ];

    return (
        <Box
            sx={{
                py: 8,
                px: 2,
                textAlign: 'center',
                background: '#FBF7F2'
            }}
        >
            <Typography variant="h4" component="h2" gutterBottom>
                Koncept
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Your plan, your plate, your progress
            </Typography>

            <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
                <Typography variant="body2" sx={{ mr: 1 }}>Monthly</Typography>
                <Switch checked={annual} onChange={() => setAnnual(prev => !prev)} />
                <Typography variant="body2" sx={{ ml: 1 }}>Annual</Typography>
            </Box>

            <Grid container spacing={3} justifyContent="center">
                {plans.map((plan, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                borderRadius: 2,
                                boxShadow: 2,
                                p: 2,
                                height: '100%'
                            }}
                        >
                            <CardContent>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    {plan.title}
                                </Typography>
                                <Typography variant="h4" component="div" sx={{ mb: 1 }}>
                                    {annual ? plan.annualPrice + " CZK/year" : plan.monthlyPrice + " CZK/month"} <Typography component="span" variant="body2"></Typography>
                                </Typography>
                                <Divider sx={{ my: 2 }} />
                                {plan.features.map((feature, i) => (
                                    <Typography key={i} variant="body2" sx={{ mb: 1 }}>
                                        {feature}
                                    </Typography>
                                ))}
                                <Box mt={3}>
                                    <Button variant="contained" color="primary" fullWidth sx={{ mb: 1 }}>
                                        Select Plan
                                    </Button>
                                    <Button variant="text" color="primary" fullWidth>
                                        Learn more
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
